/* LP bio-ethanol keuzehulp per merk (Ecosy, Planika, Wild Flame), 10-10-2026.
   Zelfde logica als de algemene keuzehulp (lp-bioethanol-keuzehulp-0910.js):
   vragen -> advies met 3 kaarten -> Shopify contactformulier (+ bij toestemming een klant met tags) -> doorsturen naar de gekozen haard.
   Het merk komt uit <div class="bek" data-bek-brand="ecosy|planika|wildflame">. */
(function () {
  'use strict';
  var root = document.querySelector('.bek[data-bek-brand]');
  if (!root) return;
  var BRAND = root.getAttribute('data-bek-brand');
  var BRAND_NAME = { ecosy: 'Ecosy', planika: 'Planika', wildflame: 'Wild Flame' }[BRAND] || BRAND;
  var STORE = 'bekbrand_' + BRAND;

  /* ---------- Hulpjes ---------- */
  function $(id) { return document.getElementById(id); }
  function euro(cents) { return '€' + Math.round(cents / 100).toLocaleString('nl-NL'); }
  function track(ev, data) { try { window.dataLayer && window.dataLayer.push(Object.assign({ event: ev, bek_brand: BRAND }, data || {})); } catch (e) {} }
  function param(name) { try { return new URLSearchParams(location.search).get(name) || ''; } catch (e) { return ''; } }

  /* ---------- Advertentie-match: kop volgt de advertentie (utm_content bevat BE1..BE7, of ?hook=BE1) ---------- */
  var adName = param('utm_content') || '';
  var hookMatch = (param('hook') || adName).match(/\bBE\s*-?\s*(\d+)\b/i);
  var hook = hookMatch ? 'BE' + hookMatch[1] : '';
  try { if (adName || param('utm_campaign')) sessionStorage.setItem(STORE + '_ad', [param('utm_campaign'), adName].filter(Boolean).join(' / ')); } catch (e) {}
  var startSlide = 0;
  if (hook && root.querySelector('[data-hook="' + hook + '"]')) {
    root.querySelectorAll('[data-hook]').forEach(function (el) {
      var on = el.getAttribute('data-hook') === hook;
      el.hidden = !on;
      if (on && el.hasAttribute('data-hook-slide')) startSlide = parseInt(el.getAttribute('data-hook-slide'), 10) || 0;
    });
  }

  /* ---------- Carrousel ---------- */
  var car = $('bek-car'), dots = $('bek-dots');
  if (car && dots) {
    var slides = car.querySelectorAll('.bek-slide');
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Ga naar afbeelding ' + (i + 1));
      b.addEventListener('click', function () { car.scrollTo({ left: s.offsetLeft - car.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(b);
    });
    var dotBtns = dots.querySelectorAll('button');
    var current = function () {
      var x = car.scrollLeft, best = 0, d = 1e9;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - car.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      return best;
    };
    var paint = function () { var c = current(); dotBtns.forEach(function (b, i) { b.classList.toggle('on', i === c); }); };
    car.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    root.querySelectorAll('.bek-car-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = Math.max(0, Math.min(slides.length - 1, current() + parseInt(btn.dataset.dir, 10)));
        car.scrollTo({ left: slides[t].offsetLeft - car.offsetLeft, behavior: 'smooth' });
      });
    });
    if (startSlide && slides[startSlide]) car.scrollLeft = slides[startSlide].offsetLeft - car.offsetLeft;
    paint();
  }

  /* ---------- Tabellen: kolomkop als label per cel (mobiel als kaart leesbaar) ---------- */
  root.querySelectorAll('.bek-table').forEach(function (t) {
    var h = [].map.call(t.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
    t.querySelectorAll('tbody tr').forEach(function (tr) { [].forEach.call(tr.children, function (td, i) { if (h[i]) td.setAttribute('data-label', h[i]); }); });
  });

  /* ---------- Productdata ---------- */
  var products = [];
  try { products = JSON.parse($('bek-data').textContent).products || []; } catch (e) { products = []; }
  products.forEach(function (p) { p.v = p.v || BRAND_NAME; });
  function byHandle(h) { for (var i = 0; i < products.length; i++) if (products[i].h === h) return products[i]; return null; }

  /* Wild Flame: 400+ modellen, geladen via /collections/wild-flame?view=bek-data (template collection.bek-data) */
  var WF_SKIP = ['bio-ethanol-inbouw-doorkijkhaard-fame-50-cm', 'bio-ethanol-doorkijkhaard-fame-80-cm-volledig-glas'];
  function wfFamily(p) {
    var t = (p.t || '').toLowerCase(), y = (p.y || '').toLowerCase(), m = t.match(/(\d+)\s*[×x]\s*(\d+)\s*cm/i), w = t.match(/(\d+)\s*cm/i);
    p.w = m ? +m[1] : w ? +w[1] : 0;
    p.ht = m ? +m[2] : 0;
    if (WF_SKIP.indexOf(p.h) > -1) return 'skip';
    if (/smart fire|automatische/.test(t)) return 'smart';
    if (/plafond/.test(y + t)) return /aura|curve/.test(t) ? 'plafond-aura' : 'plafond-ova';
    if (/^selected box/.test(t)) return 'box';
    if (/^main deluxe/.test(t)) return 'deluxe';
    if (/^saint u/.test(t)) return 'drie';
    if (/^saint|^made verticale/.test(t)) return 'rd-v';
    if (/^made/.test(t)) return 'drie';
    if (/hoek/.test(y + t)) return /verticale/.test(y + t) ? (/links/.test(t) ? 'hoek-l' : 'hoek-r') : 'hoek-h';
    if (/verticale enkelzijdige/.test(y) || (/selected/.test(t) && /verticale/.test(t))) return 'vert-enkel';
    if (/selected/.test(t)) return 'selected';
    if (/doorkijk|fame/.test(y + t)) return /vertica/.test(y + t) ? 'fame-v' : 'fame-h';
    return 'other';
  }
  var loading = null;
  function loadWF() {
    if (BRAND !== 'wildflame') return Promise.resolve();
    if (loading) return loading;
    var get = function (n) {
      return fetch('/collections/wild-flame?view=bek-data&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [], pages: 1 }; })
        .catch(function () { return { products: [], pages: 1 }; });
    };
    loading = get(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= Math.min(first.pages || 1, 4); n++) rest.push(get(n));
      return Promise.all(rest).then(function (more) {
        var seen = {};
        [first].concat(more).forEach(function (pg) {
          (pg.products || []).forEach(function (p) {
            if (seen[p.h]) return;
            seen[p.h] = 1;
            p.v = 'Wild Flame';
            p.f = wfFamily(p);
            products.push(p);
          });
        });
      });
    });
    return loading;
  }
  function fam(f) { return products.filter(function (p) { return p.f === f; }); }
  function nearest(list, target, key) {
    return list.slice().sort(function (a, b) { var d = Math.abs((a[key] || 0) - target) - Math.abs((b[key] || 0) - target); return d !== 0 ? d : a.p - b.p; });
  }

  /* ---------- Vragen per merk ---------- */
  var KIDS = { id: 'kinderen', q: 'Zijn er jonge kinderen of huisdieren in huis?', o: [['ja', 'Ja', ''], ['nee', 'Nee', '']] };
  var WHEN = { id: 'wanneer', q: 'Wanneer wil je bij het vuur zitten?', o: [['1m', 'Binnen een maand', ''], ['3m', 'Over 1 tot 3 maanden', ''], ['orient', 'Ik oriënteer me nog', '']] };

  var QUESTIONS = {
    ecosy: [
      { id: 'plaats', q: 'Waar komt je Ecosy te staan?', o: [
        ['woonkamer', 'In de woonkamer of eetkamer', 'De klassieke plek voor een kachel'],
        ['tuinkamer', 'In een tuinkamer, serre of gesloten overkapping', 'Met dak en wanden rondom'],
        ['anders', 'In een andere ruimte', 'Bijv. werkkamer of appartement']] },
      { id: 'look', q: 'Wat vind je het belangrijkst aan het vuur?', o: [
        ['klassiek', 'Klassiek, met een houtblokvak', 'De echte houtkachel-look'],
        ['breed', 'Zo breed mogelijk vuurzicht', 'Een groot raam op de vlammen'],
        ['drie', 'Vuur van drie kanten zien', 'Glas aan de voorkant en de zijkanten'],
        ['hoog', 'Vuur hoger, op ooghoogte vanaf de bank', 'Kachel op een sokkel'],
        ['compact', 'Compact, voor een kleinere plek', 'Past ook in een smalle schouw'],
        ['weetniet', 'Weet ik nog niet', 'Laat me de populairste zien']] },
      { id: 'opstelling', q: 'Hoe komt de kachel te staan?', o: [
        ['nis', 'In een bestaande schouw of nis', 'We checken of hij past'],
        ['vrij', 'Vrij in de kamer of tegen een wand', 'Geen maatbeperking in de hoogte'],
        ['weetniet', 'Weet ik nog niet', '']] },
      { id: 'nis', when: function (a) { return a.opstelling === 'nis'; }, q: 'Hoe hoog is de opening van je schouw of nis?', o: [
        ['75', 'Lager dan 75 cm', ''],
        ['100', '75 tot 100 cm', ''],
        ['110', '100 tot 110 cm', ''],
        ['999', 'Hoger dan 110 cm', ''],
        ['0', 'Weet ik niet precies', 'We meten het samen na']] },
      { id: 'ruimte', q: 'Hoe groot is de ruimte waar de kachel komt?', o: [
        ['klein', 'Kleiner dan 10 m²', ''], ['middel', '10 tot 25 m²', ''], ['groot', 'Groter dan 25 m²', ''], ['weetniet', 'Weet ik niet precies', '']] },
      KIDS, WHEN
    ],
    planika: [
      { id: 'plaats', q: 'Waar wil je het vuur?', o: [
        ['vrijstaand', 'Vrijstaand in de kamer', 'Neerzetten en stekker erin'],
        ['wand', 'Aan de wand', 'Zwevend, zonder verbouwing'],
        ['weetniet', 'Weet ik nog niet', 'Laat me de populairste zien']] },
      { id: 'stijl', when: function (a) { return a.plaats === 'vrijstaand' || a.plaats === 'weetniet'; }, q: 'Welke uitstraling past bij je interieur?', o: [
        ['zwart', 'Strak en zwart', 'Een blikvanger in een licht interieur'],
        ['wit', 'Licht en wit', 'Rustig in een lichte kamer'],
        ['rond', 'Rond, op pootjes', 'Speels design'],
        ['weetniet', 'Geen voorkeur', '']] },
      { id: 'duur', q: 'Hoe lang wil je per keer stoken?', o: [
        ['kort', 'Een paar uur per keer', 'Een avond op de bank'],
        ['lang', 'Lang, zonder tussendoor bij te vullen', 'Hele avonden of weekenden'],
        ['weetniet', 'Weet ik nog niet', '']] },
      { id: 'ruimte', q: 'Hoe groot is de ruimte waar de haard komt?', o: [
        ['klein', 'Kleiner dan 15 m²', ''], ['middel', '15 tot 25 m²', ''], ['groot', 'Groter dan 25 m²', ''], ['weetniet', 'Weet ik niet precies', '']] },
      { id: 'budget', q: 'Wat is je budget voor de haard?', o: [
        ['1500', 'Tot €1.500', ''], ['2000', '€1.500 – €2.000', ''], ['0', 'Eerst advies, dan budget', '']] },
      KIDS, WHEN
    ],
    wildflame: [
      { id: 'plaats', q: 'Waar wil je het vuur?', o: [
        ['inbouw', 'Ingebouwd in de tv-wand of schouw', 'Strak weggewerkt'],
        ['doorkijk', 'Tussen twee ruimtes (doorkijk of roomdivider)', 'Vuur van twee kanten zichtbaar'],
        ['hoek', 'In een hoek', 'Glas aan twee zijden'],
        ['wand', 'Aan de wand hangen', 'Geen koof of verbouwing nodig'],
        ['plafond', 'Zwevend aan het plafond', 'Een echte eyecatcher'],
        ['weetniet', 'Weet ik nog niet', 'Laat me de populairste zien']] },
      { id: 'vorm', when: function (a) { return a.plaats === 'inbouw' || a.plaats === 'doorkijk' || a.plaats === 'hoek'; }, q: 'Liggend of staand vuur?', o: [
        ['liggend', 'Liggend: breed en laag', 'Klassiek onder de tv of in de schouw'],
        ['staand', 'Staand: smal en hoog', 'Een verticale lijn van vuur']] },
      { id: 'zijden', when: function (a) { return a.plaats === 'inbouw' && a.vorm === 'liggend'; }, q: 'Hoe wil je het vuur zien?', o: [
        ['een', 'Alleen van voren', 'Klassiek in de tv-wand of schouw'],
        ['drie', 'Van drie kanten', 'Voor een uitstekende wand of schouw'],
        ['hout', 'Met decoratieve houtblokken ernaast', 'Rustiek en symmetrisch']] },
      { id: 'maat', when: function (a) { return (a.plaats === 'inbouw' || a.plaats === 'doorkijk' || a.plaats === 'hoek') && a.vorm === 'liggend'; }, q: 'Hoe breed mag het vuur worden?', o: [
        ['80', '60–90 cm', 'Compact'], ['120', '100–130 cm', 'Meest gekozen'], ['150', '140–170 cm', 'Ruim'], ['190', '180–200 cm', 'Statement'], ['120x', 'Weet ik nog niet', 'We denken mee']] },
      { id: 'hoogte', when: function (a) { return a.plaats === 'wand' || ((a.plaats === 'inbouw' || a.plaats === 'doorkijk' || a.plaats === 'hoek') && a.vorm === 'staand'); }, q: 'Hoe hoog mag het vuur worden?', o: [
        ['110', '100–120 cm', 'Ook voor lagere wanden'], ['150', '140–160 cm', 'Meest gekozen'], ['190', '180–200 cm', 'Van vloer tot ooghoogte'], ['150x', 'Weet ik nog niet', 'We denken mee']] },
      { id: 'pmaat', when: function (a) { return a.plaats === 'plafond'; }, q: 'Hoe groot mag de plafondhaard zijn?', o: [
        ['80', 'Ca. 80 cm', 'Voor een kleinere zithoek'], ['100', 'Ca. 100 cm', 'De gulden middenweg'], ['120', 'Ca. 120 cm', 'Maximaal effect']] },
      { id: 'wkleur', when: function (a) { return a.plaats === 'wand'; }, q: 'Welke kleur past bij je wand?', o: [
        ['zwart', 'Zwart', 'Strak en stoer'], ['wit', 'Wit', 'Licht en rustig'], ['geen', 'Geen voorkeur', 'Laat me beide zien']] },
      { id: 'bediening', when: function (a) { return a.plaats === 'inbouw' && a.vorm === 'liggend' && a.zijden === 'een'; }, q: 'Hoe wil je de haard bedienen?', o: [
        ['handmatig', 'Handmatig', 'Aansteken met een lange aansteker. Eenvoudig en voordeliger.'],
        ['auto', 'Volledig automatisch', 'App, sensoren en pompsysteem (Smart Fire).'],
        ['geen', 'Geen voorkeur', 'Laat me de opties zien']] },
      { id: 'budget', q: 'Wat is je budget voor de haard?', o: [
        ['1500', 'Tot €1.500', ''], ['2500', '€1.500 – €2.500', ''], ['4000', '€2.500 – €4.000', ''], ['99999', 'Meer dan €4.000', ''], ['0', 'Eerst advies, dan budget', '']] },
      KIDS, WHEN
    ]
  };
  var Q = QUESTIONS[BRAND] || [];
  var LABEL = {};
  Q.forEach(function (q) { LABEL[q.id] = { q: q.q }; q.o.forEach(function (o) { LABEL[q.id][o[0]] = o[1]; }); });

  /* ---------- Advies per merk ---------- */
  var ECOSY = {
    'ecosy-vista-500': { hgt: 85.5, look: 'klassiek', why: 'De Vista 500 is de klassieke Ecosy: een gietijzeren kachel met houtblokvak, 85,5 cm hoog en 65 kg.' },
    'ecosy-panoramic': { hgt: 55.6, look: 'breed', why: 'De Panoramic heeft het breedste vuurzicht (56 cm breed) en een grotere brander van 1,4 liter.' },
    'ecosy-nordliv-high': { hgt: 75.5, look: 'drie', why: 'De Nordliv High laat het vuur aan drie kanten zien: de meest moderne Ecosy.' },
    'ecosy-vista-500-pedestal': { hgt: 95.5, look: 'hoog', why: 'De Vista 500 Pedestal staat op een sokkel, zodat het vuur hoger zit: mooi zichtbaar vanaf de bank.' },
    'ecosy-windsor-7': { hgt: 59.5, look: 'compact', why: 'De Windsor 7 is de compactste Ecosy: 46 cm breed en 59,5 cm hoog.' }
  };
  var ECOSY_ORDER = {
    klassiek: ['ecosy-vista-500', 'ecosy-vista-500-pedestal', 'ecosy-nordliv-high', 'ecosy-windsor-7', 'ecosy-panoramic'],
    breed: ['ecosy-panoramic', 'ecosy-nordliv-high', 'ecosy-vista-500', 'ecosy-windsor-7', 'ecosy-vista-500-pedestal'],
    drie: ['ecosy-nordliv-high', 'ecosy-panoramic', 'ecosy-vista-500', 'ecosy-vista-500-pedestal', 'ecosy-windsor-7'],
    hoog: ['ecosy-vista-500-pedestal', 'ecosy-vista-500', 'ecosy-nordliv-high', 'ecosy-panoramic', 'ecosy-windsor-7'],
    compact: ['ecosy-windsor-7', 'ecosy-panoramic', 'ecosy-nordliv-high', 'ecosy-vista-500', 'ecosy-vista-500-pedestal'],
    weetniet: ['ecosy-vista-500', 'ecosy-panoramic', 'ecosy-nordliv-high', 'ecosy-windsor-7', 'ecosy-vista-500-pedestal']
  };

  function adviceEcosy(a) {
    var why = [], order = (ECOSY_ORDER[a.look] || ECOSY_ORDER.weetniet).slice(), nis = parseInt(a.nis, 10) || 0;
    var title = a.look && a.look !== 'weetniet' ? 'Ons advies: de ' + (byHandle(order[0]) ? byHandle(order[0]).t.split('|')[0].trim() : 'Ecosy') : 'Ons advies: begin bij deze Ecosy kachels';
    if (nis) {
      /* 15 cm vrij boven de kachel; modellen die passen eerst */
      var fits = order.filter(function (h) { return ECOSY[h].hgt + 15 <= nis; });
      var rest = order.filter(function (h) { return fits.indexOf(h) < 0; });
      if (fits.length && fits[0] !== order[0]) {
        why.push('Je favoriete uitvoering is hoger dan je nis toelaat. We tonen eerst de modellen die met 15 cm vrije ruimte erboven passen.');
        title = 'Ons advies: een Ecosy die in je nis past';
      }
      order = fits.concat(rest);
      if (!fits.length) why.push('Een nis lager dan 75 cm is krap. Mike kijkt graag met je mee of een Ecosy past; stuur gerust een foto met de maten.');
    }
    var cards = order.map(byHandle).filter(Boolean).slice(0, 3);
    if (cards[0] && ECOSY[cards[0].h]) why.push(ECOSY[cards[0].h].why);
    why.push('Elke Ecosy is van staal en gietijzer, met een handmatige brander: neerzetten, bijvullen en aansteken. Geen schoorsteen, gas of stroom nodig. Tot 3 kW warmte.');
    if (a.opstelling === 'nis' || a.opstelling === 'vrij') why.push('Houd minimaal 10 cm vrij aan de zijkanten, 15 cm boven de kachel en 50 cm tot gordijnen.');
    if (a.plaats === 'tuinkamer') why.push('In een tuinkamer of overkapping mag een Ecosy alleen als de ruimte volledig dicht, droog en tochtvrij is, bijvoorbeeld met glazen schuifwanden rondom.');
    if (a.ruimte === 'klein') why.push('Let op: Ecosy schrijft een minimale ruimte-inhoud van 25 m³ voor. Bij een plafond van 2,5 meter is dat ongeveer 10 m² vloeroppervlak. We rekenen het samen na.');
    if (a.kinderen === 'ja') why.push('Met jonge kinderen of huisdieren: de kachel en het glas worden heet. Plaats eventueel een haardscherm en vul alleen bij als de brander helemaal is afgekoeld.');
    return { title: title, why: why, cards: cards };
  }

  var PLANIKA = {
    arcZ: 'ethanol-haard-arcticon-bev-technology',
    arcW: 'bio-ethanol-haard-arcticon-wit-bev-technology-planika',
    bubble: 'vrijstaande-bio-ethanol-haard-bubble'
  };
  var PLANIKA_WHY = {};
  PLANIKA_WHY[PLANIKA.arcZ] = 'De Arcticon heeft een aparte tank van 5 liter met een automatisch vulsysteem: tot 20 uur vuur per tankvulling, max. 3,5 kW. Minimale ruimte-inhoud 35 m³.';
  PLANIKA_WHY[PLANIKA.arcW] = PLANIKA_WHY[PLANIKA.arcZ].replace('De Arcticon', 'De Arcticon in wit');
  PLANIKA_WHY[PLANIKA.bubble] = 'De Bubble is rond (Ø 65 cm) en speels: vrijstaand op pootjes of aan de wand (beide sets meegeleverd). Je vult hem met de meegeleverde automatische pomp: tot 4,5 uur vuur en max. 2,5 kW. Minimale ruimte-inhoud 25 m³.';

  function advicePlanika(a) {
    var P = PLANIKA, why = [], order, title, budget = +(a.budget || 0);
    switch (a.plaats) {
      case 'wand': order = [P.bubble, P.arcZ, P.arcW]; title = 'Ons advies: de Planika Bubble aan de wand'; break;
      default:
        order = ({ zwart: [P.arcZ, P.arcW, P.bubble], wit: [P.arcW, P.arcZ, P.bubble], rond: [P.bubble, P.arcZ, P.arcW] })[a.stijl] || [P.arcZ, P.arcW, P.bubble];
        title = a.plaats === 'weetniet' ? 'Ons advies: begin bij de Planika Arcticon' : 'Ons advies: een vrijstaande Planika';
    }
    var front = function (h) { order = [h].concat(order.filter(function (x) { return x !== h; })); };
    var wantsBubble = a.plaats === 'wand' || a.stijl === 'rond';
    if (a.ruimte === 'klein' && !wantsBubble) { front(P.bubble); title = 'Ons advies voor een kleinere ruimte'; }
    if (a.duur === 'lang' && !wantsBubble) { front(a.stijl === 'wit' ? P.arcW : P.arcZ); title = 'Ons advies: de Planika Arcticon met 5 liter tank'; }
    if (budget && budget <= 1500) { front(P.bubble); title = 'Ons advies binnen jouw budget'; }
    var cards = order.map(byHandle).filter(Boolean).slice(0, 3);
    if (cards[0] && PLANIKA_WHY[cards[0].h]) why.push(PLANIKA_WHY[cards[0].h]);
    why.push('Planika werkt met BEV-technologie: de brander verbrandt ethanoldamp, de vlam komt niet in contact met de vloeibare brandstof. Je bedient de vlam met de afstandsbediening.');
    why.push('Je hebt geen schoorsteen of gasaansluiting nodig, wel een stopcontact (230 V). De Arcticon en de Bubble zijn alleen voor binnen.');
    if (a.duur === 'lang' && wantsBubble) why.push('Wil je lange avonden stoken zonder bij te vullen? Dan is de Arcticon met zijn tank van 5 liter (tot 20 uur vuur) een optie; die staat vrij op de vloer, is niet rond en hangt niet aan de wand.');
    if (a.ruimte === 'klein') why.push('Let op: elk model heeft een minimale ruimte-inhoud (25 m³ voor de Bubble, 35 m³ voor de Arcticon). Reken lengte × breedte × hoogte; we checken het samen.');
    if (a.kinderen === 'ja') why.push('Met kinderen of huisdieren is een automatische haard een logische keuze: je vult nooit bij naast een vlam. Het glas wordt wel heet; denk aan een haardscherm.');
    if (budget && budget < 99999 && cards[0] && cards[0].p / 100 > budget) why.push('Het eerste model valt boven je budget. In je persoonlijke advies laten we ook voordeligere opties zien.');
    return { title: title, why: why, cards: cards };
  }

  function adviceWildFlame(a) {
    var cards = [], why = [], title = 'Jouw advies', budget = +(a.budget || 0);
    var add = function (p) { if (p && cards.indexOf(p) < 0 && cards.length < 3) cards.push(p); };
    var take = function (list, n) { list.slice(0, n || 1).forEach(add); };
    switch (a.plaats) {
      case 'inbouw':
        if (a.vorm === 'staand') {
          title = 'Ons advies: een verticale Wild Flame inbouwhaard';
          take(nearest(fam('vert-enkel'), parseInt(a.hoogte, 10) || 150, 'ht'), 2);
          take(nearest(fam('fame-v'), parseInt(a.hoogte, 10) || 150, 'ht'), 1);
          why.push('Een staande lijn van vuur, ingebouwd in de wand, met glas aan de voorkant.');
        } else {
          var w = parseInt(a.maat, 10) || 120;
          if (a.zijden === 'drie') {
            title = 'Ons advies: een driezijdige Wild Flame inbouwhaard';
            take(nearest(fam('drie'), w, 'w'), 3);
            why.push('Een driezijdige haard laat het vuur zien aan de voorkant en aan beide zijkanten: ideaal in een uitstekende tv-wand of schouw. Je kiest uit Made en Saint U-vorm, van 60 tot 200 cm breed.');
          } else if (a.zijden === 'hout') {
            title = 'Ons advies: Wild Flame Main Deluxe met houtblokken';
            take(nearest(fam('deluxe'), w, 'w'), 3);
            why.push('De Main Deluxe combineert het vuur achter getint glas met een frame voor decoratieve houtblokken: links, rechts of aan beide zijden.');
          } else if (a.bediening === 'auto') {
            title = 'Ons advies: de automatische Wild Flame Smart Fire';
            take(nearest(fam('smart'), w, 'w'), 2);
            take(nearest(fam('selected'), w, 'w'), 1);
            why.push('De Smart Fire A6 bedien je met een app: met een elektrische pomp, 10 vlamstanden, 7 sensoren en een kinderslot. Tot 10 uur vuur op de laagste stand.');
            if (budget && budget < 5000) why.push('De Smart Fire begint bij €5.000. Ter vergelijking tonen we ook een handmatige Selected in jouw maat.');
          } else {
            title = 'Ons advies: Wild Flame Selected voor je tv-wand';
            take(nearest(fam('selected'), w, 'w'), 3);
            why.push('De Wild Flame Selected is er in 15 breedtes van 60 tot 200 cm. We tonen de maten die het dichtst bij jouw wens liggen.');
          }
          why.push('Inbouwen doe je in een wand van onbrandbaar plaatmateriaal. Je krijgt de technische tekening van jouw maat bij je advies.');
        }
        break;
      case 'doorkijk':
        title = 'Ons advies: een Wild Flame doorkijkhaard';
        if (a.vorm === 'staand') {
          take(nearest(fam('fame-v'), parseInt(a.hoogte, 10) || 150, 'ht'), 2);
          take(nearest(fam('rd-v'), parseInt(a.hoogte, 10) || 150, 'ht'), 1);
          why.push('Staand kan ook als roomdivider met glas aan meerdere zijden: Wild Flame Saint en Made.');
        } else {
          take(nearest(fam('fame-h'), parseInt(a.maat, 10) || 120, 'w'), 2);
          take(nearest(fam('fame-v'), 140, 'ht'), 1);
        }
        why.push('Een doorkijkhaard maakt het vuur zichtbaar vanuit twee ruimtes, bijvoorbeeld woonkamer en eetkamer.');
        break;
      case 'hoek':
        title = 'Ons advies: een Wild Flame Base hoekhaard';
        if (a.vorm === 'liggend') take(nearest(fam('hoek-h'), parseInt(a.maat, 10) || 120, 'w'), 3);
        else {
          var hg = parseInt(a.hoogte, 10) || 150;
          take(nearest(fam('hoek-r'), hg, 'ht'), 1);
          take(nearest(fam('hoek-l'), hg, 'ht'), 1);
          take(nearest(fam('vert-enkel'), hg, 'ht'), 1);
        }
        why.push('Een hoekhaard heeft glas aan twee zijden. Kies links of rechts, afhankelijk van waar de muur zit.');
        break;
      case 'wand':
        title = 'Ons advies: een Wild Flame Selected Box wandhaard';
        var h = parseInt(a.hoogte, 10) || 150, box = fam('box'), col = a.wkleur === 'wit' ? 'wit' : a.wkleur === 'zwart' ? 'zwart' : '';
        take(nearest(col ? box.filter(function (p) { return p.t.toLowerCase().indexOf(col) > -1; }) : box, h, 'ht'), col ? 2 : 3);
        take(nearest(box, h, 'ht'), 3);
        why.push('Je hangt de Selected Box direct aan de wand: geen koof en geen verbouwing, met frontglas voor het vuur. Leverbaar in zwart en wit.');
        break;
      case 'plafond':
        title = 'Ons advies: een zwevende Wild Flame plafondhaard';
        var pm = parseInt(a.pmaat, 10) || 120;
        if (budget >= 4000 || budget === 0) { take(nearest(fam('plafond-aura'), pm, 'w'), 1); take(nearest(fam('plafond-ova'), pm, 'w'), 2); }
        else { take(nearest(fam('plafond-ova'), pm, 'w'), 2); take(nearest(fam('plafond-aura'), pm, 'w'), 1); }
        why.push('Een plafondhaard hangt vrij in de ruimte en is van alle kanten te zien. Voor de montage aan het plafond denken we met je mee.');
        break;
      default:
        title = 'Ons advies: drie populaire startpunten';
        take(nearest(fam('selected'), 120, 'w'), 1);
        take(nearest(fam('fame-h'), 120, 'w'), 1);
        take(nearest(fam('plafond-ova'), 100, 'w'), 1);
        why.push('Twijfel je nog over de plek? Dit zijn de drie meest gekozen vormen: een inbouwhaard voor de tv-wand, een doorkijkhaard en een zwevende plafondhaard.');
    }
    if (a.kinderen === 'ja') why.push('Met jonge kinderen of huisdieren: het glas wordt heet en je vult een handmatige brander alleen bij als hij is afgekoeld. Een automatische Smart Fire heeft een kinderslot.');
    if (budget && budget < 99999 && cards[0] && cards[0].p / 100 > budget) why.push('Het eerste model valt boven je budget. In je persoonlijke advies laten we ook kleinere maten of alternatieven zien.');
    if (!cards.length) { take(fam('selected'), 3); why.push('We konden de modellen niet volledig laden. Mike stuurt je de juiste maten persoonlijk door.'); }
    return { title: title, why: why, cards: cards };
  }

  var ADVICE = { ecosy: adviceEcosy, planika: advicePlanika, wildflame: adviceWildFlame };
  /* Korte namen op de kaarten (productitels zijn lang en SEO-gericht) */
  var SHORT = {
    'ethanol-haard-arcticon-bev-technology': 'Planika Arcticon zwart',
    'bio-ethanol-haard-arcticon-wit-bev-technology-planika': 'Planika Arcticon wit',
    'vrijstaande-bio-ethanol-haard-bubble': 'Planika Bubble',
    'vertis-vrijstaande-bio-ethanolhaard-planika': 'Planika Vertis',
    'automatische-bio-ethanol-brander-senso-burner': 'Planika Senso Burner'
  };
  function shortName(p) { return SHORT[p.h] || p.t.split('|')[0].trim(); }

  /* ---------- Quiz ---------- */
  var stepsEl = $('bek-steps'), bar = $('bek-bar'), count = $('bek-count'), resultEl = $('bek-result'), quiz = $('bek-quiz');
  var answers = {};
  function active() { return Q.filter(function (q) { return !q.when || q.when(answers); }); }
  function save() { try { sessionStorage.setItem(STORE, JSON.stringify(answers)); } catch (e) {} }

  function step(i) {
    var list = active();
    if (i >= list.length) return finish();
    var q = list[i];
    bar.style.width = Math.round(i / list.length * 100) + '%';
    count.textContent = 'Vraag ' + (i + 1) + ' van ' + list.length;
    var html = '<fieldset class="bek-step"><legend>' + q.q + '</legend><div class="bek-opts">';
    q.o.forEach(function (o) {
      html += '<button type="button" class="bek-opt' + (answers[q.id] === o[0] ? ' sel' : '') + '" data-v="' + o[0] + '"><b>' + o[1] + '</b>' + (o[2] ? '<span>' + o[2] + '</span>' : '') + '</button>';
    });
    html += '</div>' + (i > 0 ? '<button type="button" class="bek-back">← Vorige vraag</button>' : '') + '</fieldset>';
    stepsEl.innerHTML = html;
    stepsEl.hidden = false;
    resultEl.hidden = true;
    count.hidden = false;
    stepsEl.querySelectorAll('.bek-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers[q.id] = btn.dataset.v;
        Q.forEach(function (x) { if (x.when && !x.when(answers)) delete answers[x.id]; });
        save();
        loadWF();
        if (i === 0) track('bek_start', { plaats: answers.plaats || '' });
        step(i + 1);
      });
    });
    var back = stepsEl.querySelector('.bek-back');
    if (back) back.addEventListener('click', function () { step(i - 1); });
  }

  var chosen = null, shown = [];
  function finish() {
    var done = false, go = function () { if (!done) { done = true; render(); } }, t = setTimeout(go, 6000);
    loadWF().then(function () { clearTimeout(t); go(); }, function () { clearTimeout(t); go(); });
  }
  function render() {
    var r = (ADVICE[BRAND] || adviceEcosy)(answers);
    shown = r.cards;
    chosen = r.cards[0] || null;
    bar.style.width = '100%';
    count.hidden = true;
    stepsEl.hidden = true;
    resultEl.hidden = false;
    $('bek-result-title').textContent = r.title;
    $('bek-why').innerHTML = r.why.map(function (w) { return '<li>' + w + '</li>'; }).join('');
    var cardsEl = $('bek-cards');
    cardsEl.innerHTML = r.cards.map(function (p, i) {
      var price = p.m > p.p ? 'vanaf ' + euro(p.p) : euro(p.p);
      return '<label class="bek-card' + (i === 0 ? ' on' : '') + '"><input type="radio" name="bek-pick" value="' + p.h + '"' + (i === 0 ? ' checked' : '') + '>' +
        (i === 0 ? '<em class="bek-badge">Beste match</em>' : '') +
        (p.i ? '<img src="' + p.i + '" alt="' + p.t.replace(/"/g, '&quot;') + '" loading="lazy" width="640" height="640">' : '') +
        '<span class="bek-card-b"><small>' + p.v + '</small><b>' + shortName(p) + '</b><span class="bek-price">' + price + '</span></span></label>';
    }).join('');
    cardsEl.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        cardsEl.querySelectorAll('.bek-card').forEach(function (c) { c.classList.remove('on'); });
        inp.closest('.bek-card').classList.add('on');
        chosen = byHandle(inp.value);
      });
    });
    quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    track('bek_result', { plaats: answers.plaats || '' });
  }
  function answersText() {
    return Object.keys(answers).map(function (k) { return (LABEL[k] ? LABEL[k].q : k) + ' → ' + ((LABEL[k] && LABEL[k][answers[k]]) || answers[k]); }).join(' | ');
  }

  /* ---------- Formulier (zelfde werkwijze als de algemene keuzehulp) ---------- */
  var form = $('bek-form'), sending = false;
  if (form) form.addEventListener('submit', function (e) {
    if (sending) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var name = form.querySelector('#bek-name'), email = form.querySelector('#bek-email'), ok = true;
    [name, email].forEach(function (f) { f.classList.remove('err'); });
    if (!name.value.trim()) { name.classList.add('err'); ok = false; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { email.classList.add('err'); ok = false; }
    if (!ok) { (name.value.trim() ? email : name).focus(); return; }
    var p = chosen || shown[0];
    var target = p ? '/products/' + p.h : root.getAttribute('data-bek-fallback') || '/collections/bio-ethanol-haarden-stijlvolle-sfeer';
    $('bek-f-product').value = p ? p.v + ' — ' + p.t + ' (' + euro(p.p) + ')' : '';
    $('bek-f-link').value = location.origin + target;
    $('bek-f-alts').value = shown.filter(function (x) { return x !== p; }).map(function (x) { return x.t; }).join(' / ');
    $('bek-f-answers').value = answersText();
    try { $('bek-f-ad').value = sessionStorage.getItem(STORE + '_ad') || ''; } catch (e2) {}
    $('bek-return').value = target + '?ref=keuzehulp-' + BRAND;
    var btn = $('bek-submit');
    btn.disabled = true;
    btn.textContent = 'Versturen…';
    track('generate_lead', { form: 'bio-ethanol-keuzehulp-' + BRAND, product: p ? p.h : '' });
    try { window.fbq && window.fbq('track', 'Lead', { content_name: p ? p.t : 'keuzehulp ' + BRAND_NAME, content_category: BRAND_NAME }); } catch (e3) {}
    /* Google Ads + GA4 lead (01-11-2026): zelfde moment als de Meta Lead, zodat Google en Meta gelijk tellen */
    try { if (window.gtag) { window.gtag('event', 'conversion', { send_to: 'AW-16631670145/8-NtCOjE_68dEIHLzPo9', value: 1.0, currency: 'EUR' }); window.gtag('event', 'generate_lead', { send_to: 'G-0VZPDHNX8M', form_id: 'bio-ethanol-keuzehulp-' + BRAND, value: 1, currency: 'EUR' }); } } catch (e5) {}
    var submitContact = function () { sending = true; setTimeout(function () { form.submit(); }, 500); };
    var optin = $('bek-optin'), cust = $('bek-cust');
    if (optin && optin.checked && cust) {
      var tags = ['bio-ethanol-keuzehulp', 'lead-bio-ethanol', 'bek-lp-' + BRAND, 'bek-merk-' + BRAND_NAME.toLowerCase().replace(/\s+/g, '-'), 'bek-' + (answers.plaats || 'onbekend')];
      if (answers.wanneer) tags.push('bek-' + answers.wanneer);
      $('bek-c-email').value = email.value.trim();
      $('bek-c-name').value = name.value.trim().split(' ')[0];
      $('bek-c-tags').value = tags.join(',');
      var fired = false, next = function () { if (!fired) { fired = true; submitContact(); } };
      $('bek-cf').addEventListener('load', function () { setTimeout(next, 300); });
      cust.target = 'bek-cf';
      try { cust.submit(); } catch (e4) { next(); }
      setTimeout(next, 8000);
    } else submitContact();
  });
  ['bek-form', 'bek-cust'].forEach(function (id) { var f = $(id); if (f) f.dataset.shopifyCaptcha = 'true'; });
  /* Terug van de Shopify-captchapagina (form_key in de URL): toon advies en formulier opnieuw */
  if (/form_key=/.test(location.search) && form && !form.querySelector('.bek-error')) {
    var d = document.createElement('div'); d.className = 'bek-error'; d.hidden = true; form.prepend(d);
  }

  $('bek-restart').addEventListener('click', function () { answers = {}; save(); step(0); quiz.scrollIntoView({ behavior: 'smooth' }); });
  root.querySelectorAll('[data-bek-start]').forEach(function (a) { a.addEventListener('click', function () { if (!Object.keys(answers).length) step(0); }); });

  try { answers = JSON.parse(sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) { answers = {}; }
  if (document.querySelector('.bek-error') && answers.plaats) finish();
  else { answers = {}; step(0); }
  quiz.dataset.ready = '1';
  if (BRAND === 'wildflame' && 'requestIdleCallback' in window) window.requestIdleCallback(loadWF);

  /* ---------- Sticky balk op mobiel ---------- */
  var sticky = $('bek-sticky'), quizWrap = $('keuzehulp'), heroCtas = root.querySelector('.bek-intro .bek-ctas');
  if (sticky && quizWrap && heroCtas && 'IntersectionObserver' in window) {
    var inQuiz = false, pastHero = false, upd = function () { sticky.classList.toggle('show', pastHero && !inQuiz); };
    new IntersectionObserver(function (en) { inQuiz = en[0].isIntersecting; upd(); }, { threshold: 0.05 }).observe(quizWrap);
    new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; upd(); }).observe(heroCtas);
  }
})();
